import SelectOptions from './SelectOptions';

export default SelectOptions;
